<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <page-header-wrapper>
      <a-card :bordered="false">



        <!--      </a-drawer>-->
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :bordered="tableBordered"
        >
      <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}}
        </span>

        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </a-card>
    </page-header-wrapper>
  </a-drawer>

</template>

<script>
import {getStatistics, getStatisticsList} from '@/api/order/order'

import { tableMixin } from '@/store/table-mixin'


export default {
  name: 'FinanceForm',
  components: {

  },
  props:{},

  mixins: [tableMixin],
  data () {
    return {
      date:[],
      list: [],
      open:false,
      orderId:null,
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        country: null,
        startTime: null,
        endTime: null,
        status: null,
        payType: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '商品类型',
          dataIndex: 'categoryName',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text === null)
              return "其他";
            else {
              return text
            }
          }

        },
        {
          title: '订单总数',
          dataIndex: 'orderNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单总金额',
          dataIndex: 'orderAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠总金额',
          dataIndex: 'discountAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '实收总金额',
          dataIndex: 'payAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '已收货订单数',
          dataIndex: 'receiveNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '待收货订单数',
          dataIndex: 'waitReceiveNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '国家',
          dataIndex: 'country',
          ellipsis: true,
          align: 'center',
          width:180,
          customRender: (text) => {
            if (text === '')
              return "其他";
            else {
              return text
            }
          }
        },
      ]
    }
  },
  filters: {
  },
  mounted() {

  },

  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    handleInfo(row, ids, queryParam) {
      console.log("当前选中行id:", row)
      console.log("传递参数:", queryParam)
      queryParam.country = row.country
      this.loading = true
      getStatisticsList(queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
        this.open = true
      })
    },

    /** 查询订单信息列表 */
    getList () {
      this.loading = true

      getStatistics(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },



  }
}
</script>
